import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentHandler } from '../../../toolkit/uicomponent';
import * as React from 'react';
import { PlaylistDetailsComponentProps, PlaylistDetailsComponentState, PlaylistDetailsComponentHandler } from './playlistdetailscomponent';
import { PlaylistDetailsCSSStyle } from './playlistdetailscss';
import { ToneDto } from '../../../../core/dto/tonedto';
import { PaginationListViewModel } from '../../../toolkit/verticallist/paginationverticallist/paginationlistviewmodel';
import { PlaylistDetailsToneViewModelImpl, PlaylistDetailsToneRowOptionsPrivilageImpl } from './playlistdetailsviewmodel';
import './playlistdetails.css';
import { ButtonComponent } from '../../../toolkit/button/buttoncomponent';
import { ButtonCSSStyleImpl } from '../../../toolkit/button/buttoncss';
import { Strings } from '../../../../utils/resources/strings';
import { ToneOptionComponent } from '../toneoption/toneoptioncomponent';
import { ImageLoaderComponent } from '../../../toolkit/imageloader/imageloadercomponent';
import { PlaylistDetailsImageLoaderCSSStyleImpl } from './playlistdetailsimageloadercss';
import { CRBTUIViewImpl } from '../crbt/crbtuiview';
import { ToneOptionsType } from '../../popup/tonedetailspopup/tonedetailspopupcomponent';
import { ToneRowOptionsPrivilageFromJsonImpl } from '../../../toolkit/toneoptions/tone/tonerowcomponent';
import { VerticalListComponent } from '../../../toolkit/verticallist/verticallistcomponent';

export class PlaylistDetailsViewImpl extends CRBTUIViewImpl
{
    private viewModel: PaginationListViewModel<ToneDto>;
    private toneOptionComponent: ToneOptionComponent;
    private privilage:PlaylistDetailsToneRowOptionsPrivilageImpl;

    constructor(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler)
    {
        super(applicationContext, uiComponentHandler);

        this.privilage = this.getPrivilage();
        this.viewModel = new PlaylistDetailsToneViewModelImpl(5, applicationContext);
    }

    bindHandlers()
    {
        this.onBuyNowClick = this.onBuyNowClick.bind(this);
        this.onDeleteClick = this.onDeleteClick.bind(this);
        this.onPlaylistSelected = this.onPlaylistSelected.bind(this);
        // this.onPlayClicked = this.onPlayClicked.bind(this);
        // this.onStopClicked = this.onStopClicked.bind(this);
    }

    getChildComponent(props: PlaylistDetailsComponentProps, state: PlaylistDetailsComponentState, cssStyle: PlaylistDetailsCSSStyle): JSX.Element
    {  
        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
             {
                this.get3dCarousel(state.playlistDtos, cssStyle)
            }
            <label style={cssStyle.getPlaylistDetailsTextCSSStyle()}>
                    {state.selectedPlaylistDto.getToneName()}
            </label>
            {this.privilage.isBuy() && <div style={cssStyle.getSubscribeCSSStyle()}>
                <ButtonComponent onClick={this.onBuyNowClick} style={new ButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.buy_now)}/>
            </div>}
            {this.privilage.isDelete() && <div style={cssStyle.getSubscribeCSSStyle()}>
                <ButtonComponent onClick={this.onDeleteClick} style={new ButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.delete)}/>
            </div>}
               <ToneOptionComponent tonePrivilage={this.privilage} toneOptionType={ToneOptionsType.PLAYLIST} ref={(item: any) => this.toneOptionComponent = item} context={props.context} toneDto={state.selectedPlaylistDto}/>

               <div style={{marginTop: "20px"}}>
                    <VerticalListComponent listViewModel={this.viewModel} context={props.context}/>
               </div>
            </div>
        );
    }

    setListOfDatas(listofTones: ToneDto[])
    {
        this.viewModel.setListDatas(listofTones);
    }

    get3dCarousel(listofPlaylistDtos: ToneDto[], cssStyle: PlaylistDetailsCSSStyle)
    {
        
        return (
            <div style={{position: "relative",width:"700px", height: "200px", display: "inline-block", justifyContent: "center", alignItems: "center", margin:0, padding: "0 60px"}}>
                 <div className="swiper-container slider_service">
                    <div className="swiper-wrapper">
                    {
                        listofPlaylistDtos.map((toneDto: ToneDto) =>
                        {
                            return <>
                            <div className="swiper-slide">
                            <div style={cssStyle.getToneImgDivCSSStyle()}>
                                {/* {(this.getUIState() as PlaylistDetailsComponentState).selectedPlaylistIndex === index
                                     && <PlayerComponent playIconName={"play_black.svg"} pauseIconName={"pause_black.svg"} playerCSSStyle={new PlaylistDetailsPlayerCSSStyleImpl(this.getContext())} isPlaying={this.initialStateOfTonePlaying} onPlayClicked={() => this.onPlayClicked(toneDto)} onStopClicked={this.onStopClicked} ref={item=>this.playerComponent=item} context={this.getUIProps().context}/>} */}
                                <ImageLoaderComponent defaultImageName={"default_image.jpg"} context={this.getContext()} imageLoaderCSSStyle={new PlaylistDetailsImageLoaderCSSStyleImpl(this.getContext())} imagePath={toneDto.getImgPath()} />
                            </div>
                            </div>
                         </>;
                        })
                    }
                     </div>
                    </div>
                        <div className="swiper-button-prev"/>
                        <div className="swiper-button-next"/>
                    </div>
        );
    }

    getNavigationPath()
    {
        return [this.getUIProps().context.getResources().getString(Strings.home),
             this.getUIProps().context.getResources().getString(Strings.tune),
             this.getUIProps().context.getResources().getString(Strings.playlist)];
    }

    getBannerImg()
    {
        return "";
    }

    // onPlayComplete(): void 
    // {
    //     this.initialStateOfTonePlaying = false;
    //     this.playerComponent !== null && this.playerComponent.onPlayComplete();
    // }
   
    // onPlayStop(): void 
    // {
    //     this.initialStateOfTonePlaying = false;
    //     this.playerComponent !== null && this.playerComponent.onPlayStop();
    // }

    onBuyNowClick():void
    {
        this.toneOptionComponent.onBuyToneClick();
    }

    private onDeleteClick(): void
    {
        (this.getUIComponentHandler() as PlaylistDetailsComponentHandler).onDeleteClicked();
    }

    // private onPlayClicked(toneDto: ToneDto): void
    // {
    //     this.initialStateOfTonePlaying = true;
    //     this.getContext().getPlayerManager()
    //                 .startPlay(toneDto.getToneUrl(), this);
    // }

    // private onStopClicked(): void
    // {
    //     this.initialStateOfTonePlaying = false;

    //     this.getContext().getPlayerManager().stopPlay();
    // }


    private onPlaylistSelected(index: number, toneDto: ToneDto)
    {
        // onClick={() => this.onPlaylistSelected(index, toneDto)}
        (this.getUIComponentHandler() as PlaylistDetailsComponentHandler).onPlaylistSelected(index, toneDto);
    }

    private getPrivilage()
    {
        let toneDto = this.getContext().getToneContext();
        let tonePrivilage = new ToneRowOptionsPrivilageFromJsonImpl();
        if(toneDto !== null)
        { 

        tonePrivilage.fromJson(toneDto.getTonePrivilage());
        }
        else
        {
            this.getUIProps().context.getRouterHistory().goBack();
        }
            return tonePrivilage;
    }
}
{/* <div className="card">
                                    <div className="sliderText">
                                        <h3>{toneDto.getToneName()}</h3>
                                    </div>
                                    <div className="content">
                                        <p>{toneDto.getArtistName()}</p>
                                        <a href="#">{"Read More"}</a>
                                    </div>
                                </div>  */}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/playlistdetails/playlistdetailsview.tsx